import { MetricTableVizViews } from '../types';
import { metricTableViewConfig } from './table-view/view-config';

export const metricTableViewConfigs = [
  {
    name: MetricTableVizViews.TABLE,
    viewConfig: metricTableViewConfig,
  },
];
